module.exports = __webpack_public_path__ + "img/sophtron_logo.png";